<template>
  <el-card class="h-full relative">
    <div class="w-full h-full">
      <div class="flex mb-20px mr-10px">
        <el-input
          size="small"
          class="mr-10px !w-50"
          placeholder="培训名称"
          maxlength="50"
          v-model="searchData.name"
          clearable
        ></el-input>
        <el-date-picker
          v-model="searchData.date"
          type="daterange"
          class="mr-10px"
          size="small"
          range-separator="至"
          :start-placeholder="`${$t('开始日期')}`"
          :end-placeholder="`${$t('结束日期')}`"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-select
          v-model="searchData.trainingType"
          size="small"
          :placeholder="`${$t('培训类型')}`"
          class="mr-10px !w-50"
          clearable
          filterable
        >
          <el-option
            v-for="(item, index) in trainingType"
            :key="index"
            :label="item.displayName"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          v-model="searchData.isExpire"
          size="small"
          :placeholder="`${$t('是否过期')}`"
          class="mr-10px !w-50"
          clearable
          filterable
        >
          <el-option
            v-for="(item, index) in isExpireList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button size="small" @click="resetText()">重置</el-button>
        <el-button size="small" type="primary" @click="sizeChange()">搜索</el-button>
        <el-button size="small" type="primary" @click="actionHandle(null, 'create')"
          >新增</el-button
        >
      </div>
      <el-table
        :data="equipDataList"
        border
        class="w-full"
        :height="tableHeight"
        stripe
        v-loading="equipTableLoading"
      >
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column label="培训名称" prop="name" show-overflow-tooltip></el-table-column>
        <el-table-column
          label="培训类型"
          prop="trainingTypeName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="关联考试计划"
          prop="associateRiskyActivityTypeStr"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="包含课件数量"
          prop="coursewareCount"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="培训累计学时" prop="coursewareTimes" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.coursewareTimes | showText('second') }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="培训包含学分"
          prop="coursewareCredits"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="开始时间" prop="trainingDateStart" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.trainingDateStart | showText('time') }}</span>
          </template></el-table-column
        >
        <el-table-column label="截止时间" prop="trainingDateEnd" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.trainingDateEnd | showText('time') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="计划状态" prop="statusName" show-overflow-tooltip></el-table-column>
        <el-table-column
          label="计划学习人数"
          prop="planStudyPersonNum"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="实际学习人数"
          prop="realityStudyPersonNum"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="发布人"
          prop="publisherName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" width="300" fixed="right">
          <template slot-scope="scope">
            <table-operate-button :key="scope.row.id" :buttons="buttonsEquip(scope.row)" />
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="sizeChange"
        @current-change="searchList"
        :current-page.sync="page.pageNo"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :page-size.sync="page.pageSize"
        :total="page.pageTotal"
        class="float-right mt-20px ml-10px"
      ></el-pagination>
    </div>
    <AddDia
      :visible.sync="showAddDialog"
      v-if="showAddDialog"
      :trainingType="trainingType"
      :courseList="courseList"
      :operateType="operateType"
      :operateData="operateData"
      @success="searchList"
    />
    <PeoperDia
      :visible.sync="showProcessDialog"
      v-if="showProcessDialog"
      :courseList="courseList"
      :trainingType="trainingType"
      :operateType="operateType"
      :operateData="operateData"
    />
  </el-card>
</template>

<script>
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
import { TrainingPlanApi, CoursewareApi } from '@wiz-api/training-management'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import utils from '@/components/safety/enumField/utils'
import dayjs from 'dayjs'
import { formatSeconds } from '../../components/EnumField'
import AddDia from '../../components/trainManage/RelTrain'
import PeoperDia from '../../components/trainManage/PersonDetail'

const dataCategoryApi = new DataCategoryApi()
const trainingPlanApi = new TrainingPlanApi()
const coursewareApi = new CoursewareApi()

export default {
  name: 'train-PlanList',
  components: { AddDia, TableOperateButton, PeoperDia },
  data() {
    return {
      equipDataList: [],
      equipTableLoading: false,
      equipTotalCount: 0,
      searchData: {
        name: '',
        trainingType: null,
        isExpire: null,
        date: [],
      },
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      showAddDialog: false,
      videoVisible: false,
      showProcessDialog: false,
      operateType: '',
      operateData: {},
      trainingType: [],
      courseList: [],
      isExpireList: [
        { value: true, label: '是' },
        { value: false, label: '否' },
      ],
    }
  },
  filters: {
    showText: (val, type) => {
      let result = ''
      if (type === 'time') {
        result = val && dayjs(val).format('YYYY-MM-DD')
      }
      if (type === 'videoTime') {
        return dayjs(result.value).format('HH:mm:ss')
      }
      if (type === 'second') {
        result = val && formatSeconds(val)
      }
      return result
    },
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 110px)'
    },
    buttonsEquip() {
      return (val) => {
        return [
          {
            text: '查看',
            click: () => {
              return this.actionHandle(val, 'read')
            },
            isShow: this.$hasAccess('read'),
          },
          {
            text: '编辑',
            click: () => {
              return this.actionHandle(val, 'update')
            },
            isShow: this.$hasAccess('update') && val.status === 0,
          },
          {
            text: '删除',
            click: () => {
              return this.deleteHandle(val)
            },
            isShow: this.$hasAccess('delete') && [0, 1].includes(val.status),
          },
          {
            text: '发布',
            click: () => {
              return this.relHandle(val)
            },
            isShow: this.$hasAccess('publish') && val.status === 0,
          },
          {
            text: '查看学习情况',
            click: () => {
              return this.goVeiewProcess(val)
            },
            isShow: val.status === 2 || val.status === 3,
          },
        ]
      }
    },
  },
  methods: {
    // 字典
    async getRegulationType() {
      const [err, res] = await dataCategoryApi.getListByCodes({
        codes: ['TrainingType'],
        includeDetails: true,
      })
      if (err) return
      // 字典-事故类型
      this.trainingType = res[0]?.dataItems
    },
    // 查看学习情况
    goVeiewProcess(data) {
      this.operateData = data
      this.showProcessDialog = true
    },
    // 获取课件列表
    async getCourse() {
      const data = {
        maxResultCount: 99, // 每页多少条
        skipCount: 0, // 跳过多少条
      }
      const [err, res] = await coursewareApi.getList(data)
      if (!err) {
        this.courseList = res.items
      }
    },
    // 操作
    actionHandle(planRow, type) {
      this.operateType = type
      this.operateData = planRow
      this.showAddDialog = true
    },
    // 删除
    deleteHandle(planRow) {
      this.$confirm('此操作将删除此计划, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        callback: async (action) => {
          if (action === 'confirm') {
            const [err, res] = await trainingPlanApi.deleteMany({ ids: [planRow.id] })
            if (!err) {
              this.$message.success(this.$t('删除成功'))
              this.sizeChange()
            }
          }
        },
      })
    },
    // 发布
    relHandle(planRow) {
      this.$confirm('此操作将发布此计划, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        callback: async (action) => {
          if (action === 'confirm') {
            const [err, res] = await trainingPlanApi.publish({ id: planRow.id })
            if (!err) {
              this.searchList()
            }
          }
        },
      })
    },
    // 重置
    resetText() {
      this.searchData = this.$options.data().searchData
      this.sizeChange()
    },
    /**
     * @description 分页数改变
     */
    sizeChange() {
      this.page.pageNo = 1
      this.searchList()
    },
    // 设备设施列表
    async searchList() {
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        maxResultCount: this.page.pageSize,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        ...searchData,
      }
      if (this.searchData.date?.length) {
        data.dateStart = this.searchData.date[0]
        data.dateEnd = this.searchData.date[1]
      }
      this.equipTableLoading = true
      const [err, res] = await trainingPlanApi.getList(data)
      this.equipTableLoading = false
      if (!err) {
        this.equipDataList = res.items
        this.page.pageTotal = res.totalCount
      }
    },
  },
  mounted() {
    this.getRegulationType()
    this.searchList()
    this.getCourse()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
